import { useAppDispatch, useAppSelector } from '../store'
import { 
    selectContextLocation as selectContextLocationInState, 
    setContextLocation as setContextLocationInState
} from 'store/applicationSlice'

export const useContextLocation = () => {
    const dispatch = useAppDispatch()
    const contextLocationFromState = useAppSelector(selectContextLocationInState) 
    const selectContextLocation = contextLocationFromState

    const setContextLocation = (contextLocation: any) => {
        dispatch(setContextLocationInState(contextLocation))
    }
  
    return {
        selectContextLocation,
        setContextLocation
    }
}